import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import AgentIntegrationSection from "../../../../contents/docs/components/AgentIntegrationSection.mdx";
import NextJSInstall from "../../../../contents/docs/integrate/_snippets/nextjs/install-nextjs.mdx";
import Tab from "components/Tab";
import InstrumentationClientSetup from "../../../../contents/docs/libraries/next-js/_snippets/instrumentation-client-access.mdx";
import ProviderAccess from "../../../../contents/docs/libraries/next-js/_snippets/provider-access.mdx";
import NextJSInstallServer from "../../../../contents/docs/integrate/_snippets/nextjs/install-nextjs-server.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  AgentIntegrationSection,
  NextJSInstall,
  Tab,
  InstrumentationClientSetup,
  ProviderAccess,
  NextJSInstallServer,
  React
};